import { sortField } from "@smart/itops-utils-basic";

import { LanguageKey, baseLanguageKey } from "../../../types";
import { EditableSection, GqlField, GqlGroup, PendingField } from "../types";

export const getOrderedSectionItems = ({
  sectionUri,
  fields,
  groups,
}: {
  sectionUri: string;
  fields: GqlField[];
  groups: GqlGroup[];
}) => {
  const sectionFields = fields.filter(
    (f) => f.values.sectionUri === sectionUri,
  );

  const sectionGroups = groups.filter(
    (g) => g.values.sectionUri === sectionUri,
  );

  return sortField(
    [
      ...(sectionFields || [])
        .filter((f) => !f.values.groupUri)
        .map((f) => f.values),
      ...(sectionGroups || []).map((g) => ({
        ...g.values,
        fields: sortField(
          sectionFields
            ?.filter((f) => f.values.groupUri === g.uri)
            .map((f) => f.values) || [],
          { key: "order", dir: "asc" },
        ),
      })),
    ],
    { key: "order", dir: "asc" },
  );
};

export const getTranslatedSections = (
  sections: EditableSection[],
  viewingLanguage: LanguageKey,
): EditableSection[] =>
  sections.map((section) => {
    const translationLabel =
      viewingLanguage !== baseLanguageKey &&
      section.values?.translations?.find(
        (translation) => translation.language === viewingLanguage,
      )?.title;
    return {
      uri: section.uri,
      values: {
        ...section.values,
        title: translationLabel || section.values?.title || "",
      },
    } as EditableSection;
  });

export const toSectionField = (pending: PendingField): GqlField =>
  ({
    uri: pending.uri,
    values: pending,
  }) as GqlField;
